import { render, staticRenderFns } from "./AudienceWizard.vue?vue&type=template&id=51317740&"
import script from "./AudienceWizard.vue?vue&type=script&lang=js&"
export * from "./AudienceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports